export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./slots.vue?vue&type=template&id=0371af1e"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/slots/slots.vue?vue&type=template&id=0371af1e
// module id = V2Kx
// module chunks = 0